module.exports = {
      id: "question-usage",
      viewBox: "0 0 29 29",
      url: __webpack_public_path__ + "sprite-b16b2d73f82c96a320ba0490c6416430.svg#question",
      toString: function () {
        return this.url;
      }
    }